import React from "react";

import { Paragraph4 } from "ui/typography";

import { IStatusProps, TStatusStyles } from "./types";

const statusStyles: TStatusStyles = {
  disabled: {
    color: "#344054",
    className: "bg-[#F2F4F7]",
  },
  success: {
    color: "#027A48",
    className: "bg-[#ECFDF3]",
  },
  error: {
    color: "#B42318",
    className: "bg-[#FEF3F2]",
  },
  warning: {
    color: "#B54708",
    className: "bg-[#FFFAEB]",
  },
  purple: {
    color: "#5925DC",
    className: "bg-[#F4F3FF]",
  },
  blue: {
    color: "#3538CD",
    className: "bg-[#EEF4FF]",
  },
  orange: {
    color: "#F49D1B",
    className: "bg-[#FEF5E7]",
  },
};

export const Status = (props: IStatusProps) => {
  const { status, text, className, customBgColor, customColor } = props;

  return (
    <Paragraph4
      fontWeight="500"
      lineHeight="18px"
      textColor={customColor ?? statusStyles[status || "success"]?.color}
      className={`py-[2px] px-2 rounded-2xl capitalize h-[22px] ${statusStyles[status || "success"]?.className} ${className}`}
      style={{
        backgroundColor: customBgColor ?? "",
      }}
    >
      {text}
    </Paragraph4>
  );
};
